(function (){

    'use strict';
    angular.module('app').controller('EditPromoCodeController',EditPromoCodeController);
    EditPromoCodeController.$Inject=[
        'data',
        'AffiliateService',
        '$uibModalInstance',
        'toastr',
        '$filter',
        'ClientService'
    ]

    function EditPromoCodeController(data,AffiliateService,$uibModalInstance,toastr,$routeParams,$filter,ClientService){
        const vm = this;
        vm.promoCode = {};
        vm.subAffiliates = [];
        vm.modalClose = modalClose;
        vm.toggleFromDatepicker = toggleFromDatepicker;
        vm.toggleToDatepicker = toggleToDatepicker;
        vm.setToDatepickerOptions = setToDatepickerOptions;
        vm.setFromDatepickerOptions = setFromDatepickerOptions;
        vm.addSubAffiliate = addSubAffiliate;
        vm.removeSubAffiliate = removeSubAffiliate;
        vm.change = changed;

        vm.discountTypeList =[
            {viewName:'Discount Value', type:'1'},
            {viewName:'Discount Percent', type:'2'},
            {viewName:'No Discount', type:''}
        ]

        vm.commissionTypeList =[
            {viewName:'Commission Value', type:'1'},
            {viewName:'Commission Percent', type:'2'},
            {viewName:'No Commission', type:''}
        ]

        vm.submit = function(form){
            if(form.$invalid){
                toastr.error('Promo code details is empty!');
                return;
            }
            update();
        }


        init();

        function changed(){
            hideSelectedData();
        }

        function init(){
            vm.promoCode = angular.copy(data);
            vm.checkSelect = true;
            vm.disableCheckBox=true;
            initializedData();
            getReferrer();
        }

        function initializedData(){
           
            if(vm.promoCode.startDate && vm.promoCode.endDate){
                vm.promoCode.startDate = new Date(vm.promoCode.startDate);
                vm.promoCode.endDate = new Date(vm.promoCode.endDate);
            }
            vm.discountType = data.discountType ==='margin' ? true : false;

            getSubAffiliateDetails();
            setFromDatepickerOptions();
            setToDatepickerOptions();
        }

        function hideSelectedData(){
            const affiliates = [];
            vm.subAffiliates.forEach(res=>{
                vm.companies= vm.companies.filter(item=> item.id !== res.owner.id);
                
            })
           
           
        }

        function addSubAffiliate(){
            vm.subAffiliates.push({owner:'',commission:''});
        }

        function removeSubAffiliate(index){
            vm.subAffiliates.splice(index, 1)
        }

        function getReferrer(data){
            AffiliateService.getUserMarketing(
                res=>{
                    
                    res.content.forEach(item => {
                        
                        item.fullname = `${item.firstName} ${item.lastName}`
                    });
                    vm.companies = res.content 
                },
                err=>{
                    toastr.error(err.message);
                },
                {
                    size:500,
                    companyMarketingId:$routeParams.id
                }
            )
        }

        function update(){
            vm.loading = true
            const payload = cleanPayload()
            AffiliateService.updatePromoCode(data.id,
                res=>{
                    vm.loading = false
                    toastr.success('Successfully updated!');
                    $uibModalInstance.close();
                },
                err=>{
                    vm.loading = false
                    toastr.error(err.message);
                },payload)
        }

        function modalClose(){
            $uibModalInstance.dismiss();
        }

        function cleanPayload(){
            const payload = {
                companyMarketingId: $routeParams.id,
                active: vm.promoCode.active,
                code: vm.promoCode.code,
                discountType:vm.discountType ? 'margin' : 'sales',
                description: vm.promoCode.description,
                discountPercent: vm.promoCode.discountPercent,
                discountValue: vm.promoCode.discountValue,
                durationDay:vm.promoCode.durationDay,
                durationMonth: vm.promoCode.durationMonth,
                durationWeek: vm.promoCode.durationWeek,
                endDate: $filter('date')(vm.promoCode.endDate, 'yyyy-MM-dd'),
                noBooking: vm.promoCode.noBooking,
                startDate:  $filter('date')(vm.promoCode.startDate, 'yyyy-MM-dd'),
                userMarketingList: userMarketingIds()
            };

            return payload;
        }

        function userMarketingIds(){
            const payload =[];
            vm.subAffiliates.forEach(affiliate => {
                payload.push({
                    userMarketingId: affiliate.owner.id,
                    commissionValue: affiliate.commissionValue ,
                    commissionPercent:affiliate.commissionPercent
                })
            });
            
            return payload
        }

        function getSubAffiliateDetails(){
           AffiliateService.subAffiliateDetails(data.id,
            res=>{
                res.forEach(sub => {
                    if(sub.commissionPercent){
                        vm.commissionType = vm.commissionTypeList.find(type=> type.type =='2')
                    }
                    if(sub.commissionValue){
                        vm.commissionType = vm.commissionTypeList.find(type=> type.type =='1')
                    }
                    sub.userMarketing.fullname = `${sub.userMarketing.firstName} ${sub.userMarketing.lastName}`;
                    vm.subAffiliates.push({owner:sub.userMarketing,commissionPercent:sub.commissionPercent,commissionValue:sub.commissionValue})

                });
                console.log(vm.subAffiliates)
            },
            err=>{
                console.log(err)
            });
        }

        function setFromDatepickerOptions() {
            vm.toDatepickerOptions = {
                minDate: vm.promoCode.startDate ? new Date(vm.promoCode.startDate) : null
            }
        }

        function setToDatepickerOptions() {
            vm.fromDatepickerOptions = {
                maxDate: vm.promoCode.endDate ? new Date(vm.promoCode.endDate) : null
            }
        }

        function toggleFromDatepicker() {
            vm.isFromDatepickerOpen = !vm.isFromDatepickerOpen;
        }

        function toggleToDatepicker() {
            vm.isToDatepickerOpen = !vm.isToDatepickerOpen;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/modal/editpromoCodeController.js